import React, { useState, useEffect } from "react";
import * as ltapi from "../../../api/leaveTypeApi";
import { toast } from "react-toastify";
import { LeaveTypesForm } from "../../forms/Master/LeaveTypesForm";
import PropTypes from "prop-types";
import { showDeleteConfirm } from "../../common/ConfirmationModal";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export default function LeaveTypesPage({ history }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [rowSelected, setRowSelected] = useState({});
  const location = useLocation();
  let defaultPagination = location.state
    ? location.state.currentPage
      ? location.state.currentPage
      : 1
    : 1;
  const [currentPage, setCurrentPage] = useState(defaultPagination);

  useEffect(getLeaveTypes, []);

  function getLeaveTypes() {
    ltapi
      .getAllLeaveTypes()
      .then((result) => {
        setIsLoading(false);
        setLeaveTypes(result);
      })
      .catch((error) => {
        setIsLoading(false);
        setLeaveTypes([]);
        showErrorMessage(t("general.fail_to_load_record") + error.message);
      });
  }

  function addNewItem() {
    history("/home/leavetypes/leavetype", {
      state: { currentPage: currentPage },
    });
  }

  function editItem(leaveTypeKey) {
    history("/home/leavetypes/leavetype/" + leaveTypeKey, {
      state: { currentPage: currentPage },
    });
  }

  function onDelete(leaveTypeKey) {
    showDeleteConfirm("Leave Type", leaveTypeKey, deleteLeaveType, t);
  }

  function deleteLeaveType(leaveTypeKey) {
    setIsLoading(true);
    ltapi
      .deleteLeaveType(leaveTypeKey)
      .then(() => {
        const newData = leaveTypes.filter(
          (item) => item.LTKey !== leaveTypeKey
        );
        setLeaveTypes(newData);
        setIsLoading(false);
        toast.success(t("general.record_deleted_successfully"));
      })
      .catch((error) => {
        setIsLoading(false);
        showErrorMessage(t("general.fail_to_delete_record") + error.message);
      });
  }

  function showErrorMessage(message) {
    toast.error(message);
  }

  function onRowSelected(value) {
    if (value.UpdatedDate) {
      value.UpdatedOn = value.UpdatedDate;
    }
    if (value.CreatedDate) {
      value.CreatedOn = value.CreatedDate;
    }
    setRowSelected(value);
  }

  return (
    <LeaveTypesForm
      isLoading={isLoading}
      leaveTypes={leaveTypes}
      onAdd={addNewItem}
      onEdit={editItem}
      onDelete={onDelete}
      onRowSelected={onRowSelected}
      rowSelected={rowSelected}
      setCurrentPage={setCurrentPage}
      currentPage={currentPage}
    />
  );
}

LeaveTypesPage.propTypes = {
  history: PropTypes.func.isRequired,
};
